<ngx-spinner bdColor="rgba(0,0,0,0)"
             size="default"
             zIndex="1"
             color="var(--s-primary-color)"
             type="ball-spin"
             [fullScreen]="false"
             name="jobListLoad">
  <p>Please wait ...</p>
</ngx-spinner>

<div class="dashboard-container" style="max-height: 84vh; overflow-y: auto;">
  <!-- <h1 class="dashboard-title">SQL Server Health Monitor</h1> -->
  <!-- Server Information Section -->
  <section class="dashboard-section">
    <div class="section-grid">
      <div class="info-card" *ngFor="let server of dbServerDetails">
        <h2>Server Information</h2>
        <div class="info-content">
          <div class="info-item">
            <span class="label">Database Name:</span>
            <span class="value">{{server.databaseName}}</span>
          </div>
          <div class="info-item">
            <span class="label">Server Name:</span>
            <span class="value">{{server.serverName}}</span>
          </div>
          <div class="info-item">
            <span class="label">Server Version:</span>
            <span class="value">{{server.serverVersion}}</span>
          </div>
          <div class="info-item">
            <span class="label">Server Edition:</span>
            <span class="value">{{server.serverEdition}}</span>
          </div>
          <div class="info-item">
            <span class="label">Server Host Machine:</span>
            <span class="value">{{server.serverHostMachineName}}</span>
          </div>
          <div class="info-item">
            <span class="label">CPU Count:</span>
            <span class="value">{{server.cpuCount}}</span>
          </div>
          <div class="info-item">
            <span class="label">Total Memory:</span>
            <span class="value">{{server.totalMemoryInMB}} MB</span>
          </div>
          <div class="info-item">
            <span class="label">Server Uptime:</span>
            <span class="value">{{server.serverUptime | date:'medium'}}</span>
          </div>
        </div>
      </div>

      <div>
        <div class="info-card">
          <h2>Query Statistics</h2>
          <div class="info-content" *ngFor="let stat of queryStats">
            <div class="info-item">
              <span class="label">Avg Response Time:</span>
              <span class="value">{{stat.averageQueryResponseTime}}ms</span>
            </div>
            <div class="info-item">
              <span class="label">Total Transactions:</span>
              <span class="value">{{stat.totalTransactions | number}}</span>
            </div>
            <div class="info-item">
              <span class="label">Transactions/sec:</span>
              <span class="value">{{stat.transactionRatePerSecond}}</span>
            </div>
          </div>
        </div>

        <div class="info-card" *ngFor="let conn of serverConnections">
          <h2>Connection Status</h2>
          <div class="info-content">
            <div class="info-item">
              <span class="label">Active Sessions :</span>
              <span class="value">{{conn.activeSessions}}</span>
            </div>
            <div class="info-item">
              <span class="label">Max Connections :</span>
              <span class="value">{{conn.maxConnections}}</span>
            </div>
            <div class="info-item">
              <span class="label">Memory Usage :</span>
              <span class="value">{{conn.memoryUsageInMB}} MB</span>
            </div>
          </div>
        </div>
      </div>

      <div class="info-card" *ngFor="let db of databaseHealthInfo">
        <div class="db-header">
          <h3>{{db.databaseName}}</h3>
          <span class="status-badge" [class.online]="db.state == 'ONLINE'"
                [class.offline]="db.state != 'ONLINE'">
            {{db.state}}
          </span>
        </div>
        <div class="info-content">
          <div class="info-item">
            <span class="label">Recovery Model:</span>
            <span class="value">{{db.recoveryModel}}</span>
          </div>
          <div class="info-item">
            <span class="label">Compatibility:</span>
            <span class="value">{{db.compatibilityLevel}}</span>
          </div>
          <div class="info-item">
            <span class="label">Deadlocks:</span>
            <span class="value">{{db.deadlockCount}}</span>
          </div>
          <div class="info-item">
            <span class="label">Last Backup:</span>
            <span class="value">{{db.lastBackupTime | date:'medium' || 'Never'}}</span>
          </div>
        </div>
      </div>



    </div>
  </section>

  <!-- Active Sessions Section -->
  <section class="card mb-4">
    <div class="card-header bg-white">
      <h3 class="mb-0" style="font-weight: 600;">Active Sessions</h3>
    </div>
    <div class="card-body p-0">
      <div class="table-responsive" style="height: 400px;">
        <!-- Adjust height as needed -->
        <table class="table table-hover table-striped mb-0">
          <thead class="position-sticky top-0 bg-light">
            <tr class="table-list-head">
              <th class="fw-semibold">Session ID</th>
              <th class="fw-semibold">Login Name</th>
              <th class="fw-semibold">Status</th>
              <th class="fw-semibold">Host</th>
              <th class="fw-semibold">Program</th>
              <th class="fw-semibold">CPU Time</th>
              <th class="fw-semibold">Elapsed Time</th>
              <th class="fw-semibold">Last Request</th>
            </tr>
          </thead>
          <tbody>
            <tr class="table-list-row jobRow" *ngFor="let session of serverSessionInfoes">
              <td>{{session.sessionId}}</td>
              <td>{{session.logInName}}</td>
              <td>
                <span class="badge" [ngClass]="{
                    'bg-success': session.sessionStatus === 'running',
                    'bg-secondary': session.sessionStatus === 'sleeping'
                  }">
                  {{session.sessionStatus}}
                </span>
              </td>
              <td>{{session.sessionHostName}}</td>
              <td>{{session.sessionProgramName}}</td>
              <td>{{session.cpuTime}}ms</td>
              <td>{{session.totalElapsedTime}}ms</td>
              <td>{{session.lastRequestStartTime | date:'medium'}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </section>

  <!-- Database Health Section -->
  <section class="dashboard-section">
    <div class="section-grid" [ngClass]="{'col-lg-8': linkedServerInfo?.length, 'col-4': !linkedServerInfo?.length}">
      <div class="info-card">
        <h3>Table Statistics</h3>
        <div class="info-content">
          <div class="info-item">
            <span class="label">Total Number Of Tables</span>
            <span class="value">{{ totalNumberOfTables }}</span>
          </div>
        </div>

        <div class="table-stats">
          <div class="table-stat-header-fixed">
            <span class="header-col">Table Name</span>
            <span class="header-col">Row Count</span>
            <span class="header-col">Data Space (MB)</span>
          </div>

          <div class="table-stats-content">
            <div class="table-stat-item" *ngFor="let table of tablesAndDataInsights">
              <div class="table-stat-header">
                <span class="table-name" [title]="table.tableName">{{ table.tableName }}</span>
                <span class="row-count">{{ table.rowCountOfTable | number }} rows</span>
                <span class="data-space">{{ table.dataSpaceMB | number:'1.2-2' }} MB</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="linkedServerInfo?.length">
        <div class="info-card" *ngFor="let link of linkedServerInfo;" style="height: 98%;">
          <h2>Linked ServerInfo</h2>
          <div class="info-content">
            <div class="info-item">
              <span class="label">Linked Server Name :</span>
              <span class="value">{{link.linkedServerName}}</span>
            </div>
            <div class="info-item">
              <span class="label">Linked Server Address :</span>
              <span class="value">{{link.serverAddress}}</span>
            </div>
            <div class="info-item">
              <span class="label">Product Name :</span>
              <span class="value">{{link.productName || '-'}}</span>
            </div>
            <div class="info-item">
              <span class="label">Modify Date :</span>
              <span class="value">{{link.modifyDate | date:'medium'}}</span>
            </div>
          </div>
        </div>
      </div>

    </div>
  </section>

</div>
